import tw from './zh-tw/index.js'
import cn from './zh-cn/index.js'

const messages = {
    'zh-TW': tw,
    'zh-CN': cn,
}

export default messages
